   var sections = $('.main_scroll .section'),
       nav = $('nav'),
       nav_height = nav.outerHeight();

   var lastId,
       cur = [];

   $(window).on('scroll', function () {
       var fromTop = $(this).scrollTop() + nav_height;

       sections.each(function () {
           var $this = $(this),
               top = $this.offset().top - nav_height,
               bottom = top + $this.outerHeight();

           if (fromTop >= top && fromTop <= bottom) {
               if ($this.attr('id') !== lastId) {
                   lastId = $this.attr('id');
                   cur = [lastId];
               }

               if (cur.length > 0) {
                   // Remove active class from previously active elements
                   $('nav a.active').removeClass('active');
                   $('section.active').removeClass('active');

                   nav.find('a[href="#' + cur.join(', #') + '"]').addClass('active');
                   $('#' + cur.join(', #')).addClass('active');
               }
           }
       });
   });

   nav.find('a').on('click', function () {
       var $el = $(this),
           id = $el.attr('href');

       $('html, body').animate({
           scrollTop: $(id).offset().top - nav_height
       }, 500);

       return false;
   });



 $('.main_sld .logo_slider').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  lazyLoad: 'ondemand', // Enable lazy loading
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});

$('.article_slider').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  lazyLoad: 'ondemand', // Enable lazy loading
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});


$('button.last_btn').click(function(){
    $('.form_sec').toggleClass('reg_form');
});

if (window.matchMedia("(max-width: 767px)").matches) {
   $('.slider_mob .logo_slider').slick({
  dots: false,
  infinite: true,
  speed: 300,
  arrows: false,
  slidesToShow: 2,
  slidesToScroll: 1
});
}

var count = localStorage.getItem("wihs_count");
$('span.count_wish').text(count);

if (window.matchMedia("(max-width: 700px)").matches) {
$(document).on("click", ".mobile_fot", function(){
    $(this).toggleClass('show_mb');
});
}


$('.related-products .product-grid').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1
});

// Slider with multiple blocks

    $('.js-custom-back-slider').each(function() {
      var slidesToShow = parseInt($(this).data('slides-to-show'));


      $(this).slick({
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        arrows:true,
              responsive: [{
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            variableWidth: !1,
                            centerMode: !1
                        }
                    }]
        // Add other options as per your requirement
      });
    });



    $('.js-blockslider').each(function() {
      var slidesToShow = parseInt($(this).data('slides-to-show'));


      $(this).slick({
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        arrows:true,
              responsive: [{
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            variableWidth: !1,
                            centerMode: !1
                        }
                    }]
        // Add other options as per your requirement
      });
    });

//promo slider 

      $(".promos-with-logo").each(function() {
           
                const e = $(this)
                  , t = e.find(".promo-with-logos__items")
                  , i = e.find(".promo-with-logos__description");
           
                let n = !1;
                t.length === i.length && (n = !0,
                t.on("click", ".slick-slide", (function() {
                    i.slick("slickGoTo", $(this).attr("data-slick-index"))
                }
                ))),
                t.slick({
                    arrows: !1,
                    dots: !1,
                    infinite: !0,
                    variableWidth: !0,
                    centerMode: !0,
                    mobileFirst: !0,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    responsive: [{
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            variableWidth: !1,
                            centerMode: !1
                        }
                    }, {
                        breakpoint: 1239,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 1,
                            variableWidth: !1,
                            centerMode: !1
                        }
                    }]
                }),
                i.slick({
                    asNavFor: n ? t : null,
                    arrows: !1,
                    dots: !1,
                    infinite: !0,
                    variableWidth: !1,
                    centerMode: !1,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: !0,
                    autoplaySpeed: 2e3
                })
            }
            )
// testimonial slider
   $(".testimonials").each((function() {
                const e = $(this)
                  , t = e.find(".testimonials__bg li")
                  , i = e.find(".testimonials__items")
                  , n = e.find(".testimonials__dots");
                i.on("beforeChange", (function(e, i, n, s) {
                    t.removeClass("active").eq(s).addClass("active")
                }
                )),
                i.slick({
                    arrows: !0,
                    dots: !0,
                    appendDots: n,
                    infinite: !1,
                    variableWidth: !1,
                    centerMode: !1
                })
            }
                           
))
// testimonia hide
    window.matchMedia("(max-width: 767px)").matches && null != document.getElementsByClassName("testimonials__items") && $(".testimonials__items").not(".slick-initialized").slick({
                    arrow: "true"
  })



$('.tab_title').click(function(){
    var check = $(this).attr('id');
   $(this).addClass('active');
  $(this).siblings().removeClass('active');
    $(".main-coll-tc .tabs-cont").each(function( index ) {
      var match = $(this).attr('data-id');
       if (check ==match){
           $(this).show();
       }else{
           $(this).hide();
       }
    });
});

 document.addEventListener("DOMContentLoaded", function() {
    var lazyImages = document.querySelectorAll('.lazy');

    var lazyLoad = function() {
      lazyImages.forEach(function(img) {
        if (img.getBoundingClientRect().top < window.innerHeight && img.getBoundingClientRect().bottom > 0 && getComputedStyle(img).display != "none") {
          img.src = img.dataset.src;
          img.classList.remove('lazy');
        }
      });
    };

    window.addEventListener('scroll', lazyLoad);
    window.addEventListener('resize', lazyLoad);
    window.addEventListener('orientationchange', lazyLoad);

    lazyLoad(); // Load initial images
  });

window.onload = function() {
  $('.less_text_button').click(function () {
    $('.less_text').hide();
    $('.more_text').show();
  });

  $('.more_text_button').click(function () {
    $('.less_text').show();
    $('.more_text').hide();
  });
};


$('.svg-icon-arc .head-svg-coll').click(function(){
    $(this).parents('.svg-icon-arc').toggleClass('show_data');
    $(this).parents('.svg-icon-arc').siblings().removeClass('show_data');
});